"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hotsprings = void 0;
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
const Resources_1 = require("../../../Resources");
class Hotsprings extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.HOTSPRINGS,
            tags: [Tags_1.Tags.BUILDING],
            startingMegaCredits: 48,
            metadata: {
                cardNumber: 'R48',
                description: 'You start with 48 M€ and 5 heat.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br.br;
                    b.megacredits(48).heat(5);
                    b.corpBox('action', (ce) => {
                        ce.vSpace();
                        ce.action('Increase your M€ production 1 step if your heat production was raised 1 step this generation, or 2 steps if it was raised more than 1 step this generation', (eb) => {
                            eb.empty().startAction.production((pb) => pb.megacredits(1)).slash().production((pb) => pb.megacredits(2)).asterix();
                        });
                    });
                }),
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.HEAT, 5);
        return undefined;
    }
    canAct(player) {
        return player.heatProductionStepsIncreasedThisGeneration > 0;
    }
    action(player) {
        if (player.heatProductionStepsIncreasedThisGeneration === 1) {
            player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        }
        else if (player.heatProductionStepsIncreasedThisGeneration > 1) {
            player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        }
        return undefined;
    }
}
exports.Hotsprings = Hotsprings;
//# sourceMappingURL=Hotsprings.js.map